module.exports = __webpack_public_path__ + "img/Flag_of_Malta.ab9b100c.svg";